"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconItalic', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M4.80005 15.154L4.99373 14.3029C5.43889 14.0258 5.90102 13.8025 6.37479 13.6358L8.13479 2.22625L7.19163 2.01922C6.9811 2.01922 6.88005 1.84669 6.88005 1.65117C6.91793 1.34379 7.00727 1.05252 7.1411 0.800049H11.2L11.0064 1.65117C10.5612 1.92834 10.0991 2.15156 9.62531 2.31826L7.83163 13.7278L8.77479 13.9809C8.98531 13.9809 9.08637 14.1534 9.08637 14.3489C9.05863 14.6525 8.98089 14.9434 8.859 15.2L4.80005 15.154Z'],
  params: {
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M6 17.9489L6.24211 17.0032C6.79856 16.6952 7.37621 16.4472 7.96842 16.262L10.1684 3.58466L8.98947 3.35463C8.72632 3.35463 8.6 3.16294 8.6 2.94569C8.64735 2.60416 8.75902 2.28052 8.92632 2H14L13.7579 2.94569C13.2014 3.25365 12.6238 3.50168 12.0316 3.6869L9.78947 16.3642L10.9684 16.6454C11.2316 16.6454 11.3579 16.8371 11.3579 17.0543C11.3232 17.3916 11.2261 17.7149 11.0737 18L6 17.9489Z'],
  params: {
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M7.19995 22.7309L7.49048 21.4543C8.15822 21.0385 8.85141 20.7037 9.56206 20.4536L12.2021 3.33925L10.7873 3.02871C10.4715 3.02871 10.32 2.76992 10.32 2.47663C10.3768 2.01557 10.5108 1.57866 10.7115 1.19995H16.7999L16.5094 2.47663C15.8417 2.89238 15.1485 3.22722 14.4378 3.47727L11.7473 20.5916L13.1621 20.9712C13.4778 20.9712 13.6294 21.23 13.6294 21.5233C13.5878 21.9786 13.4712 22.415 13.2884 22.7999L7.19995 22.7309Z'],
  params: {
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M9.6001 30.3081L9.98747 28.6058C10.8778 28.0515 11.802 27.6051 12.7496 27.2717L16.2696 4.45249L14.3833 4.03844C13.9622 4.03844 13.7601 3.69339 13.7601 3.30233C13.8359 2.68759 14.0145 2.10504 14.2822 1.6001H22.4001L22.0127 3.30233C21.1224 3.85667 20.1982 4.30312 19.2506 4.63652L15.6633 27.4557L17.5496 27.9618C17.9706 27.9618 18.1727 28.3068 18.1727 28.6979C18.1173 29.3049 17.9618 29.8869 17.718 30.4001L9.6001 30.3081Z'],
  params: {
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;